import api from "../utils/API";

const getAllTypeDocuments  = () => {
  return api.get('/Type_Document/list');
};

const addTypeDocument = (type) => {
    return api.post('/Type_Document/add', { type }); 
  };

export {
    getAllTypeDocuments,
    addTypeDocument
};